"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _FulfillmentConfigurationList = _interopRequireDefault(require("../presentational/FulfillmentConfigurationList"));

var _actions = require("../actions");

var _actions2 = require("../../versionslist/actions");

var _actions3 = require("../../componentshell/actions");

var mapStateToProps = function mapStateToProps(_ref) {
  var fulfillmentConfigurationListReducer = _ref.fulfillmentConfigurationListReducer;
  return {
    availableFulfillmentConfigurations: fulfillmentConfigurationListReducer.availableFulfillmentConfigurations,
    filteredFulfillmentConfigurations: fulfillmentConfigurationListReducer.filteredFulfillmentConfigurations,
    selectedFulfillmentConfiguration: fulfillmentConfigurationListReducer.selectedFulfillmentConfiguration,
    fulfillmentConfigurationLoadingError: fulfillmentConfigurationListReducer.fulfillmentConfigurationLoadingError,
    isLoadingFulfillmentConfigurations: fulfillmentConfigurationListReducer.isLoadingFulfillmentConfigurations
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    selectFulfillmentConfiguration: function selectFulfillmentConfiguration(_ref2) {
      var fulfillmentConfigurationId = _ref2.fulfillmentConfigurationId,
          fulfillmentConfigurationName = _ref2.fulfillmentConfigurationName;
      return dispatch((0, _actions.selectFulfillmentConfiguration)({
        fulfillmentConfigurationId: fulfillmentConfigurationId,
        fulfillmentConfigurationName: fulfillmentConfigurationName
      }));
    },
    clearSelectedFulfillmentConfiguration: function clearSelectedFulfillmentConfiguration() {
      return dispatch((0, _actions.clearSelectedFulfillmentConfiguration)());
    },
    clearSelectedVersion: function clearSelectedVersion() {
      return dispatch((0, _actions2.clearSelectedVersion)());
    },
    showVersionsList: function showVersionsList() {
      return dispatch((0, _actions3.showVersionsList)());
    },
    loadFulfillmentConfigurations: function loadFulfillmentConfigurations() {
      return dispatch((0, _actions.loadFulfillmentConfigurations)({
        accessToken: ownProps.accessToken,
        buyerAccountId: ownProps.buyerAccountId,
        productConfigurationUrl: ownProps.productConfigurationUrl
      }));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FulfillmentConfigurationList["default"]);

exports["default"] = _default;